<template>
  <header id="header" class="header">
    <div class="wrapper-box overflow-h">
      <div class="logo fl">
        <img src="../../static/img/web_img/logo.png" />
      </div>
      <div class="fr nav-list">
        <router-link v-for="(item,index) in nav_list" :to="item.url" :key="index">{{item.name}}</router-link>
      </div>
      <button @click="show_menu=true" type="button" class="navbar-toggle"><span class="icon-bar"></span> <span class="icon-bar"></span> <span
          class="icon-bar"></span></button>
      <div v-if="show_menu" class="navbar-collapse">
        <div class="overflow-h">
          <Icon @click="show_menu=false" class="fr mb10" type="md-close" size='30'/>
        </div>
        <div class="list">
          <router-link v-for="(item,index) in nav_list" :to="item.url" :key="index">{{item.name}}</router-link>
        </div>

      </div>
    </div>
  </header>
</template>

<script>
  export default {
    data() {
      return {
        show_menu:false,
        nav_list: [{
          name: '首页',
          url: '/Index'
        }, {
          name: '业务介绍',
          url: '/Intro'
        }, {
          name: '关于我们',
          url: '/AboutUs'
        },
        // {
        //   name: '合作伙伴',
        //   url: '/Partner'
        // },
        {
          name: '联系我们',
          url: '/Contact'
        }, {
          name: '个人中心',
          url: '/Home'
        } ]
      }
    },
    mounted() {
      let height = $("#header").height();
      console.log(height)
      window.onscroll = function() {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        console.log("滚动距离" + scrollTop);
        if(scrollTop>height){
          $("#header").css('opacity',0.9)
        }else{
          $("#header").css('opacity',1)
        }
      }
    }
  }
</script>


<style lang="scss" scoped src="../../static/css/enter/main.scss"></style>



// WEBPACK FOOTER //
// src/components/header.vue